(() => {
  const roots = document.querySelectorAll('[data-maker-package-claim]');

  roots.forEach((root) => {
    const button = root.querySelector('[data-claim-button]');
    if (!button) return;

    const ready = root.querySelector('[data-state-ready]');
    const auth = root.querySelector('[data-state-auth]');
    const success = root.querySelector('[data-state-success]');
    const error = root.querySelector('[data-claim-error]');
    const title = root.querySelector('[data-claim-title]');
    const balance = root.querySelector('[data-claim-balance]');
    const endpoint = root.dataset.claimEndpoint;

    const resetButton = () => {
      button.disabled = false;
      button.textContent = 'Claim 20 Free Designs';
    };

    button.addEventListener('click', async () => {
      button.disabled = true;
      button.textContent = 'Claiming...';
      error.hidden = true;

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        const data = await response.json().catch(() => ({}));

        if (data.error === 'not_logged_in' || (response.status === 401 && data.error !== 'invalid_signature')) {
          resetButton();
          ready.hidden = true;
          auth.hidden = false;
          auth.focus();
          return;
        }

        if (response.status === 404 || data.error === 'unknown_campaign') {
          throw new Error('claim_not_ready');
        }

        if (!response.ok || (!data.claimed && !data.already_claimed && data.ok !== true)) {
          throw new Error(data.error || 'claim_unavailable');
        }

        title.textContent = data.already_claimed
          ? 'Your package bonus is ready'
          : '20 free designs added';
        if (Number.isFinite(Number(data.after ?? data.free_left))) {
          balance.textContent = `${Number(data.after ?? data.free_left)} designs available`;
        }
        ready.hidden = true;
        auth.hidden = true;
        success.hidden = false;
        success.focus();
      } catch (claimError) {
        error.textContent = claimError.message === 'claim_not_ready'
          ? 'This bonus is temporarily unavailable. No designs were added. Please try again later.'
          : 'We could not confirm your claim. No designs were added. Please try again.';
        error.hidden = false;
        resetButton();
      }
    });
  });
})();
